import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var VehicleListRes;
export const VehicleListTodo = createAsyncThunk('VehicleList', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Get",
            url: process.env.REACT_APP_API_URL + 'vehicle_master',
            params: {
                "vehicle_status": "",
                "search": data ? data : ''
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return VehicleListRes = res.data

    } catch (error) {
        return VehicleListRes = error.response.data
    }
})

const VehicleListSlice = createSlice({
    name: 'VehicleList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(VehicleListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(VehicleListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default VehicleListSlice.reducer; 